import React from 'react';

function TrashIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={22}
      height={22}
      viewBox="0 0 22 22"
      fill="none">
      <path
        d="M2.75 5.5H4.58333H19.25"
        stroke="#17385D"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.33301 5.50065V3.66732C7.33301 3.18109 7.52616 2.71477 7.86998 2.37096C8.2138 2.02714 8.68011 1.83398 9.16634 1.83398H12.833C13.3192 1.83398 13.7856 2.02714 14.1294 2.37096C14.4732 2.71477 14.6663 3.18109 14.6663 3.66732V5.50065M17.4163 5.50065V18.334C17.4163 18.8202 17.2232 19.2865 16.8794 19.6303C16.5356 19.9742 16.0692 20.1673 15.583 20.1673H6.41634C5.93011 20.1673 5.4638 19.9742 5.11998 19.6303C4.77616 19.2865 4.58301 18.8202 4.58301 18.334V5.50065H17.4163Z"
        stroke="#17385D"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.16699 10.084V15.584"
        stroke="#17385D"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.833 10.084V15.584"
        stroke="#17385D"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default TrashIcon;
